import React, { useState, useEffect } from "react";
import { FaPhoneAlt, FaBars, FaTimes, FaChevronDown } from "react-icons/fa";
import { Link } from "react-router-dom";
import MegaMenu from "./MegaMenu";
import "../styles/Navbar.css";
import logo from "../assets/idlogo.png";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [mobileDropdownStates, setMobileDropdownStates] = useState({
    services: false,
    branches: false,
    nris: false,
  });

  useEffect(() => {
    document.body.classList.toggle("menu-open", isOpen);
    return () => document.body.classList.remove("menu-open");
  }, [isOpen]);

  const toggleMobileDropdown = (key) => {
    setMobileDropdownStates(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  // Function to handle service click - scroll to section on services page
  const handleServiceClick = (sectionId) => {
    // Close mobile menu if open
    if (isOpen) {
      setIsOpen(false);
    }
    
    // If already on services page, scroll to section
    if (window.location.pathname === "/services") {
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 100);
    }
  };

  /* ================= SERVICES DATA ================= */
  const services = {
    personal: [
      { name: "Pre-Marriage Verification", sectionId: "pre-marriage-verification" },
      { name: "Post-Marriage Investigation", sectionId: "post-marriage-investigation" },
      { name: "Cheating Spouse Investigation", sectionId: "cheating-spouse-investigation" },
      { name: "Love Affair Investigation", sectionId: "love-affair-investigation" },
      { name: "Divorce Investigation", sectionId: "divorce-investigation" }
    ],
    corporate: [
      { name: "Employee Verification", sectionId: "employee-verification" },
      { name: "Employee Integrity", sectionId: "employee-integrity" },
      { name: "Corporate Due Diligence", sectionId: "corporate-due-diligence" },
      { name: "Financial Fraud", sectionId: "financial-fraud" },
      { name: "Insider Threats", sectionId: "insider-threats" },
      { name: "Startup Fraud", sectionId: "startup-fraud" },
    ],
    popular: [
      { name: "Pre-Marriage Verification", sectionId: "pre-marriage-verification" },
      { name: "Cheating Spouse Investigation", sectionId: "cheating-spouse-investigation" },
      { name: "Employee Verification", sectionId: "employee-verification" },
      { name: "Corporate Due Diligence", sectionId: "corporate-due-diligence" },
      { name: "Financial Fraud Investigation", sectionId: "financial-fraud" },
      { name: "NRI Matrimonial Fraud Investigation", sectionId: "nri-matrimonial-investigation" },
    ],
  };

  /* ================= NRI DATA ================= */
  const nriData = [
    { name: "NRI Matrimonial Investigation", link: "/services#nri-matrimonial-investigation", sectionId: "nri-matrimonial-investigation" },
    { name: "NRI Background Verification", link: "/services#nri-background-verification", sectionId: "nri-background-verification" },
    { name: "NRI Property Disputes", link: "/services#nri-property-disputes", sectionId: "nri-property-disputes" },
    { name: "NRI Fraud Investigation", link: "/services#nri-fraud-investigation", sectionId: "nri-fraud-investigation" },
    { name: "NRI Legal Support", link: "/services#nri-legal-support", sectionId: "nri-legal-support" },
    { name: "NRI Due Diligence", link: "/services#nri-due-diligence", sectionId: "nri-due-diligence" },
    { name: "NRI Asset Tracing", link: "/services#nri-asset-tracing", sectionId: "nri-asset-tracing" },
    { name: "NRI Document Verification", link: "/services#nri-document-verification", sectionId: "nri-document-verification" },
  ];

  /* ================= BRANCHES DATA ================= */
  const branchesData = [
    { name: "Delhi", link: "/contact-us" },
     { name: "Delhi NCR", link: "/contact-us" },
      { name: "Rajasthan", link: "/contact-us" },
       { name: "Punjab", link: "/contact-us" },
        { name: "Haryana", link: "/contact-us" },
         { name: "Chandigarh", link: "/contact-us" },
          { name: "Uttrakhand", link: "/contact-us" },
           { name: "Himanchal", link: "/contact-us" },
           { name: "Uttarpradesh", link: "/contact-us" },
           { name: "Bihar", link: "/contact-us" },
           { name: "Madhya Pradesh", link: "/contact-us" },
           { name: "All India Service", link: "/contact-us" },
  ];

  /* ================= MENUS ================= */
  const menus = {
    services: [
      {
        title: "Personal Investigation",
        items: services.personal.map((s) => ({
          name: s.name,
          link: `/services#${s.sectionId}`,
          sectionId: s.sectionId
        })),
      },
      {
        title: "Corporate Investigation",
        items: services.corporate.map((s) => ({
          name: s.name,
          link: `/services#${s.sectionId}`,
          sectionId: s.sectionId
        })),
      },
      {
        title: "🔥 Popular",
        type: "popular",
        items: services.popular.map((s) => ({
          name: s.name,
          link: `/services#${s.sectionId}`,
          sectionId: s.sectionId
        })),
      },
    ],

    branches: [
      {
        title: "Our Branches",
        items: branchesData,
      },
    ],

    nris: [
      {
        title: "Services for NRIs",
        items: nriData,
      },
    ],
  };

  /* ================= NAV ITEMS ================= */
  const navItems = [
    { name: "Home", href: "/" },
    { name: "Our Services", key: "services", hasDropdown: true },
    { name: "Our Branches", key: "branches", hasDropdown: true },
    { name: "About Us", href: "/about-us" },
    { name: "Contact Us", href: "/contact-us" },
    { name: "For NRIs", key: "nris", hasDropdown: true },
  ];

  return (
    <nav className="navbar">
      <div className="nav-container">

        {/* LOGO */}
        <div className="logo">
          <Link to="/">
            <img src={logo} alt="logo" className="logo-img" />
          </Link>
        </div>

        {/* DESKTOP */}
        <div className="nav-links desktop">
          {navItems.map((item, i) => (
            <div key={i} className="nav-item">
              {item.hasDropdown ? (
                <div className="dropdown-trigger">
                  <span className="nav-link">
                    {item.name} <FaChevronDown className="dropdown-icon" />
                  </span>

                  <MegaMenu data={menus[item.key]} />
                </div>
              ) : (
                <Link to={item.href} className="nav-link">
                  {item.name}
                </Link>
              )}
            </div>
          ))}
        </div>

        {/* CALL BUTTON */}
        <div className="call-btn desktop">
          <a href="tel:+917428203483" className="btn-call">
            <FaPhoneAlt /> Call Now +91 7428203483
          </a>
        </div>

        {/* MOBILE ICON */}
        <button className="mobile-icon" onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>

      {/* MOBILE MENU */}
      <div className={`mobile-menu ${isOpen ? "active" : ""}`}>
        {navItems.map((item, i) => (
          <div key={i}>
            {item.hasDropdown ? (
              <>
                <div
                  className="mobile-dropdown-trigger"
                  onClick={() => toggleMobileDropdown(item.key)}
                >
                  {item.name}
                  <FaChevronDown
                    className={mobileDropdownStates[item.key] ? "rotated" : ""}
                  />
                </div>

                <div
                  className={`mobile-dropdown-content ${
                    mobileDropdownStates[item.key] ? "open" : ""
                  }`}
                >
                  {menus[item.key].map((section, idx) => (
                    <div key={idx} className="mobile-service-section">
                      <h4>{section.title}</h4>
                      {section.items.map((s, i) => (
                        <Link 
                          key={i} 
                          to={s.link} 
                          onClick={() => setIsOpen(false)}
                        >
                          {s.name}
                        </Link>
                      ))}
                    </div>
                  ))}
                </div>
              </>
            ) : (
              <Link to={item.href} className="mobile-nav-link" onClick={() => setIsOpen(false)}>
                {item.name}
              </Link>
            )}
          </div>
        ))}

        <a href="tel:+918512834020" className="btn-call-mobile" onClick={() => setIsOpen(false)}>
          <FaPhoneAlt /> Call Now +91 8512834020
        </a>
      </div>
    </nav>
  );
};

export default Navbar;